import { useOktaAuth } from '@okta/okta-react';
import { LoginCallback } from '@okta/okta-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomLoginCallback = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authState && authState.isAuthenticated) {
      // Redirect authenticated users to the root
      navigate('/');
    } else if (authState && !authState.isAuthenticated) {
      // Redirect unauthenticated users to the Okta login page
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth, navigate]);

 

  // Render the standard LoginCallback if the user is not authenticated
  return <LoginCallback />;
};

export default CustomLoginCallback;
